var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M15.1436 79.5192C12.6718 70.6212 15.2105 60.3075 20.2569 52.1678C25.2616 44.0698 32.8159 38.1875 40.4539 32.4724C48.1336 26.7155 55.9388 21.1676 64.958 18.9201C74.019 16.631 84.3775 17.6423 92.1917 22.5356C100.006 27.4289 105.318 36.2458 108.708 45.1447C112.057 54.0017 113.527 62.9824 113.911 72.5468C114.254 82.153 113.594 92.343 108.421 99.188C103.29 105.991 93.6874 109.491 84.1265 113.2C74.5238 116.867 64.9212 120.701 56.3581 119.148C47.7532 117.553 40.1876 110.489 32.6219 103.257C25.0979 95.9832 17.6156 88.5008 15.1436 79.5192Z",
    fill: "#061303"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 53,
    y: 71,
    width: 13,
    height: 11,
    rx: 2,
    fill: "#061303"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 68,
    y: 71,
    width: 13,
    height: 11,
    rx: 2,
    fill: "#061303"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 68,
    y: 57,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#061303"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 53,
    y: 58,
    width: 13,
    height: 11,
    rx: 2,
    fill: "#061303"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectorder);
export default __webpack_public_path__ + "static/media/selectorder.aaad5dfc2342b7e321967d122f7ab9b6.svg";
export { ForwardRef as ReactComponent };